<template>
    <div class="text-center ">
      <div style="width:1.5rem; height:1.5rem; border-width: 0.15em;" v-if="isLoading" class="spinner-border mt-5"></div>
    </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'DataLoader',
  components: {},
  data() {
    return {
      isLoading:false
    }
  },
  props:[],
  methods: {
      start() {
          this.isLoading = true;
      },

      stop() {
        this.isLoading = false;
      }
  },


}
</script>
